import { render } from "./App.vue?vue&type=template&id=149e8882"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=149e8882&lang=css"

import exportComponent from "/builds/2022/tjusls-china/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__